<template>
  <div class="score-bar">
    <div
      v-for="player in playersWithScore"
      :key="player.id"
      class="score-cell"
      :class="{ active: player.id === currentPlayerId }"
    >
      <span v-if="player.id === dealerId" class="dealer-dot" aria-label="Deler" />
      <span class="cell-name">{{ player.name }}</span>
      <span class="cell-score">{{ player.score }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useBoerenbridgeStore } from '../../stores/boerenbridge'

export default {
  name: 'BbScoreBar',
  props: {
    currentPlayerId: { type: Number, default: null }
  },
  computed: {
    ...mapState(useBoerenbridgeStore, ['playersWithScore', 'activeDealerId']),
    dealerId() {
      return this.activeDealerId
    }
  }
}
</script>

<style scoped>
.score-bar {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  background: rgba(0, 0, 0, 0.12);
}

.score-cell {
  flex: 1 1 4.25rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
  padding: 0.4rem 0.4rem 0.35rem;
  background: #fff;
  border-radius: 8px;
  border: 2px solid transparent;
  min-width: 0;
}

.score-cell.active {
  border-color: #2c3e50;
}

.dealer-dot {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: #2c3e50;
}

.cell-name {
  font-size: 0.78rem;
  font-weight: 600;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
}

.cell-score {
  font-size: 1.2rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1;
}

@media (min-width: 600px) {
  .score-bar {
    gap: 0.6rem;
    padding: 0.6rem 1.5rem;
  }

  .score-cell { padding: 0.45rem 0.5rem 0.4rem; }

  .cell-name { font-size: 0.9rem; }

  .cell-score { font-size: 1.35rem; }
}
</style>
